const suiteImgValue = {
  1: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-sea.png',
  2: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-sky.png',
  3: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-star.png'
}
const suiteTagImgValue = {
  1: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-tag-sea.png',
  2: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-tag-sky.png',
  3: 'https://resource.rcclchina.com.cn/cruiseDetail/suite/suite-tag-star.png'
}
const suiteTagStrValue = {
  1: 'SEA',
  2: 'SKY',
  3: 'STAR'
}

const deviceFeatureTags = [{
  id: '1',
  name: '豪华住宿',
  icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/washProtect/icon-dresser.png`
},{
  id: '2',
  name: '寰宇美食',
  icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/washProtect/icon-dresser.png`
},{
  id: '3',
  name: '招牌演出',
  icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/washProtect/icon-dresser.png`
}];

const deviceGroupTags = [{
  id: 1,
  name: "基础设备",
  deviceTags: [{
    id: 11,
    icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/basicDevices/icon-single-bed.png`,
    name: '2张双人床(可合并)',
    isFeature: true
  },{
    id: 12,
    icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/basicDevices/icon-private-balcony.png`,
    name: '私人阳台',
    isFeature: false
  },{
    id: 13,
    icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/basicDevices/icon-sofa.png`,
    name: '沙发',
    isFeature: false
  },{
    id: 14,
    icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/basicDevices/icon-wardrobe.png`,
    name: '衣柜',
    isFeature: false
  }]
},{
  id: 2,
  name: "洗护沐浴",
  deviceTags: [{
    id: 21,
    icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/washProtect/icon-shower.png`,
    name: '淋浴',
    isFeature: false
  },{
    id: 22,
    icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/washProtect/icon-dresser.png`,
    name: '梳妆台',
    isFeature: false
  },{
    id: 23,
    icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/washProtect/icon-hair-drier.png`,
    name: '吹风机',
    isFeature: true
  },{
    id: 24,
    icon: `${process.env.VUE_APP_IMG_URL}/cruiseDetail/icons/washProtect/icon-towel.png`,
    name: '毛巾浴巾',
    isFeature: false
  }]
}]
export default {
  suiteImgValue,
  suiteTagImgValue,
  suiteTagStrValue,
  deviceFeatureTags,
  deviceGroupTags
}
